import { useTheme } from "react-native-elements";
import RNProgressBar from "react-native-progress/Bar";

export function ProgressBar(props: any) {
  const theme = useTheme();
  // @ts-ignore The progressBar is not part of react-native-elements
  return <RNProgressBar color={theme.theme.colors.progressBar} {...props} />;
}
